const locale = {
	// #region Chronology fields
	DETAILS_CHRONOLOGY_FIELD_TITLE: 'Title',
	DETAILS_CHRONOLOGY_FIELD_DATE: 'Date',
	DETAILS_CHRONOLOGY_FIELD_COMPANY: 'Company',
	DETAILS_CHRONOLOGY_FIELD_STATUS: 'Event Status',
	DETAILS_CHRONOLOGY_FIELD_TYPE: 'Event Type',
	DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_CHRONOLOGY_FIELD_GROUP: 'Group',
	DETAILS_CHRONOLOGY_FIELD_WARNING: 'Warning',
	DETAILS_CHRONOLOGY_FIELD_BLOCKED: 'Blocked',
	DETAILS_CHRONOLOGY_FIELD_TAGS: 'Tags'
	// #endregion
};

export default locale;
